import classNames from 'classnames/bind'
import styles from './Header.module.scss'
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined'
import { Avatar, IconButton } from '@mui/material'
import React from 'react'
import { useAppSelector } from '~/app/hooks'
import {
  currentTheme,
  drawerSetting,
  selectAuth,
  setDrawerSetting
} from '~/redux/features'
import { DEFAULT_ROLES } from '~/constants'
import { UserDropdownMenu } from './UserDropdownMenu'
import { FleetNavButton } from '~/components'
import {
  // BellIcon,
  HelpIcon,
  HealthStatusIcon
} from '~/components/EFIcons'
import MenuIcon from '@mui/icons-material/Menu'
import { useMobileView } from '~/hooks/useMobileView'
import { useDispatch } from 'react-redux'
import { t } from 'i18next'

const cx = classNames.bind(styles)

interface HeaderProps {
  onToggleDrawer: () => void
}
export const Header = ({ onToggleDrawer }: HeaderProps) => {
  const isMobile = useMobileView()
  const dispatch = useDispatch()
  const theme = useAppSelector(currentTheme)
  const AuthState = useAppSelector(selectAuth)
  const { isShowDrawer } = useAppSelector(drawerSetting)
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)

  function handleMouseEnter(event: React.MouseEvent<HTMLElement>) {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget)
    }
  }

  function handleClose() {
    setAnchorEl(null)
  }

  function showRole(roles: string[]) {
    for (const role of DEFAULT_ROLES) {
      if (roles.includes(role)) {
        switch (role) {
          case 'Admin': return t('Value_Admin')
          case 'InternalServer': return t('Value_InternalServer')
          case 'Maintainer': return t('Value_Maintainer')
          case 'Technician': return t('Value_Technician')
          case 'ReadOnly': return t('Value_ReadOnly_')
          case 'Manager': return t('Value_Manager')
          case 'InfrastructureManager': return t('Value_InfrastructureManager')
          case 'InfrastructureTechnician': return t('Value_InfrastructureTechnician')
        }
      }
    }

    return null
  }

  return (
    <div className={cx('container', theme)}>
      {isShowDrawer && isMobile && (
        <button
          type='button'
          onClick={() => dispatch(setDrawerSetting({ isShowDrawer: false }))}
          className={cx('backdrop')}
        ></button>
      )}
      <IconButton
        id='btn-toggle-drawer'
        className={cx('wrapper-icon', theme, !isMobile ? 'hide' : '')}
        title='Toggle Menu'
        onClick={onToggleDrawer}
      >
        <MenuIcon />
      </IconButton>
      <FleetNavButton />
      <div className={cx('right-side')}>
        {/* <div className={cx('icon-container')}>
          <IconButton
            id='btn-notify'
            className='wrapper-icon'
          >
            <BellIcon
              height={33}
              width={33}
            />
          </IconButton>
        </div> */}
        {!isMobile && (
          <div className={cx('icon-container')}>
            <HealthStatusIcon />
          </div>
        )}
        {!isMobile && (
          <div className={cx('icon-container')}>
            <a href='/help/default_CSH.htm' target='_blank'>
            <IconButton
              id='btn-help'
              title='Help'
              className='wrapper-icon'
            >
              <HelpIcon
                height={33}
                width={33}
              />
            </IconButton>
            </a>
          </div>
        )}
        <div
          className={cx('user-infor', theme)}
          onMouseLeave={handleClose}
          onMouseEnter={handleMouseEnter}
        >
          <Avatar
            className={cx('avatar', { transparentClass: !!AuthState.profilePictureUrl })}
            src={AuthState.profilePictureUrl}
          >
            {AuthState.fullName?.charAt(0).toUpperCase()}
          </Avatar>
          {!isMobile && (
            <button
              type='button'
              className={cx('user-dropdown-wrapper')}
              aria-owns={anchorEl ? 'user-menu' : undefined}
              aria-haspopup='true'
            >
              <div className={cx('user-wrapper')}>
                <span className={cx('user-name')}>{AuthState.fullName}</span>
                <span className={cx('user-role')}>{showRole(AuthState.roles)}</span>
              </div>
              <div className={cx('more-action')}>
                <KeyboardArrowDownOutlinedIcon />
              </div>
            </button>
          )}
          <UserDropdownMenu
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
          />
        </div>
      </div>
    </div>
  )
}
